import { mixpanel } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';
import { getDataFromStores } from '../../../../shared/utils';
import { BrandnameAndSlogan, IndustriesAndBusiness } from '../../shared/types';
import store from '../../store';

export const reportBrandNameSloganSubmit = (
    { industries = [], business }: IndustriesAndBusiness,
    { brandName, slogan }: BrandnameAndSlogan
) => {
    const keywords = !!business && business.split(',');

    mixpanel.track('Logo Maker - MP Brief - Brand & Slogan Submitted', {
        ...getDataFromStores(
            store.listingsType,
            store.searchQuery,
            store.sourcePage,
            store.position,
            store.page
        ),
        [MIXPANEL_EVENT_PROPERTIES.CTA_CLICKED]: industries[0],
        [MIXPANEL_EVENT_PROPERTIES.INDUSTRY]: industries,
        [MIXPANEL_EVENT_PROPERTIES.INDUSTRY_COUNT]: industries.length,
        [MIXPANEL_EVENT_PROPERTIES.KEYWORDS]: keywords ? keywords : [],
        [MIXPANEL_EVENT_PROPERTIES.KEYWORDS_COUNT]: keywords
            ? keywords.length
            : 0,
        [MIXPANEL_EVENT_PROPERTIES.BRAND_NAME]: brandName,
        [MIXPANEL_EVENT_PROPERTIES.SLOGAN]: slogan,
    });
};
